'use strict';

angular.module('TurneroApp').component('coCentrosLogin', {
    bindings: {
        centroAtencionSeleccionado: '<',
        mostrarConfig: '<',
        centroAtencionCallback: '&',
        clickCallback: '&'
    },
    controller: [
        'centrosAtencionService',
        'TurneroAppConstant',
        'utilsService',
        'generalService',
        function (centrosAtencionService, TurneroAppConstant, utilsService, generalService) {
            var ctrl = this;
            //ctrl.tipoLogIn= 'Llamador' / 'Recepcion'
            ctrl.loading = true;

            ctrl.configuracion = false;
            ctrl.loginCentro = true;
            //ctrl.listaTimbres = TurneroAppConstant.TimbresArray;
            ctrl.llamador = {};

            ctrl.clearSearchTerm = function () {
                ctrl.searchTerm = '';
            };
            ctrl.clearSearchTerm();

            ctrl.$onChanges = function () {
                if (!ctrl.centroAtencionSeleccionado) {
                    ctrl.loginReload();
                    ctrl.centroAtencion = '';
                }

                centrosAtencionService.Get_Centro_Atencion_Combo().$promise.then(function (centrosAtencion) { //obtiene el listado de centros de atencion y los vincula al combo
                    ctrl.centrosAtencionLista = centrosAtencion;
                    if (localStorage.loginCentro == "[object Object]") {
                        delete localStorage.loginCentro;
                    }

                    if (localStorage.loginCentro && localStorage.loginCentro != 'null') {
                        ctrl.centroAtencion = angular.fromJson(localStorage.loginCentro)
                        ctrl.centroAtencionSeleccionado = ctrl.centroAtencion;
                    }
                    ctrl.loading = false;
                    ctrl.setFocus();
                }).catch(function (error) {
                    ctrl.loading = false;
                    utilsService.errores(error);
                });
            };

            ctrl.seleccionarCentro = function (centroAtencionSeleccionado) {
                ctrl.centroAtencionSeleccionado = angular.fromJson(centroAtencionSeleccionado);
                localStorage.loginCentro = JSON.stringify(centroAtencionSeleccionado);
            };

            ctrl.Ingresar = function (llamada) {

                if (ctrl.validarLogin()) {
                    centrosAtencionService.Login_Centro({
                        'id_centro_atencion': ctrl.centroAtencionSeleccionado.id, 'clave_autogestion': ctrl.password
                    }).$promise.then(function (resultado) {



                        if (llamada != 'Recepcion' && resultado[0] == '0') {
                            sweetAlert("Acceso denegado", 'El centro de atención seleccionado no posee un llamador activo.', "error");
                            return;
                        }

                        ctrl.centroAtencionCallback({
                            centroAtencionSeleccionado: ctrl.centroAtencionSeleccionado
                        });

                        ctrl.clickCallback({
                            redirect: llamada
                        });


                    }).catch(function (error) {
                        //utilsService.customError(error, 'error', "Acceso denegado");
                        var res = error.data ? error.data.split("-") : error.data.split("-");
                        if (res[0].trim() == "ADV") {
                            if (res[1] != null) {
                                swal({
                                    title: "Acceso denegado",
                                    html: res[1].trim(),
                                    type: 'warning',
                                    confirmButtonColor: '#004b81',
                                    confirmButtonText: 'Aceptar'
                                }).then(function () {
                                    if (callback) {
                                        callback();
                                    };
                                })
                            }
                            else {
                                swal({
                                    title: "Acceso denegado",
                                    html: "Algo ocurrió  y no se pudo completar la acción.<br/> Intente nuevamente o comuníquese con soporte. </br><span style='display:none'> " + res[0].trim() + "</span>",
                                    type: 'error',
                                    confirmButtonColor: '#004b81',
                                    confirmButtonText: 'Aceptar',
                                    allowEscapeKey: false,
                                    allowOutsideClick: false
                                });
                            }
                        }
                        else {
                            sweetAlert("Oops...", "Algo ocurrió  y no se pudo completar la acción.<br/> Intente nuevamente o comuníquese con soporte. </br><span style='display:none'> " + res[0].trim() + "</span>", "error");
                        }
                    });

                }
            };

            ctrl.validarLogin = function () {
                if (ctrl.centroAtencionSeleccionado) {
                    if (ctrl.password) {
                        return true;
                    }
                    else {
                        sweetAlert("Campo requerido", "El campo contraseña no puede estar vacío.", "error");
                    }
                } else {
                    sweetAlert("Campo requerido", "Seleccione un centro de atención.", "error");
                }
                return false;
            }

            ctrl.limpiarMemoria = function () {
                ctrl.loginCentro = false;
            }

            ctrl.loginReload = function () {
                ctrl.limpiarMemoria()
                ctrl.loginCentro = true;
                ctrl.password = '';
            };


            ctrl.querySearch = function (query) {
                var results = query ? ctrl.centrosAtencionLista.filter(createFilterFor(utilsService.removeAccents(query))) : ctrl.centrosAtencionLista,
                    deferred;
                if (ctrl.simulateQuery) {
                    deferred = $q.defer();
                    $timeout(function () { deferred.resolve(results); }, Math.random() * 1000, false);
                    return deferred.promise;
                } else {
                    return results;
                }
            }
            function createFilterFor(query) {
                var upperQuery = angular.uppercase(query);
                return function filterFn(centro) {
                    centro = utilsService.removeAccents(angular.lowercase(centro.text))
                    return (angular.uppercase(centro).indexOf(upperQuery) >= 0);
                };
            }
            ctrl.setFocus = function () {
                setTimeout(function () {
                    document.querySelector('#autoCompleteId').focus();
                }, 0);
            }





            ctrl.getVersion = function () {
                generalService.Get_Version().$promise.then(function (resultado) {
                    if (resultado) {
                        ctrl.version = resultado.Version;
                        ctrl.entorno = resultado.Entorno;
                        TurneroAppConstant.vedi.url = resultado.VeDiUrl;
                        TurneroAppConstant.vedi.veDiIdAplicacion = resultado.VeDiIdAplicacion;
                        TurneroAppConstant.vedi.ciDiUrlRelacion = resultado.CiDiUrlRelacion;
                    }
                }) 
            }
            ctrl.getVersion();

            ctrl.getServer = function () {

                generalService.Get_Server_Id().$promise.then(function (resultado) {
                    ctrl.server = resultado.Data;
                }).catch(function (error) {

                })
            }

            ctrl.getServer();

        }
    ],
    template: require('./centros_login.html')
});



// WEBPACK FOOTER //
// ./app/components/loginCentros/centros_loginComponent.js